import ForecastWeatherData from "./ForecastWeatherData";

export default ForecastWeatherData;